import * as React from 'react';
import * as PropTypes from 'prop-types';
import { classNames } from '@progress/kendo-react-common';
var CardTitle = function (props) {
    return (React.createElement("div", { style: props.style, className: classNames('k-card-title', props.className) }, props.children));
};
CardTitle.propTypes = {
    className: PropTypes.string
};
export default CardTitle;
//# sourceMappingURL=CardTitle.js.map